export const IconButton = (props: { title: string; icon: any; onClick: any; active: boolean }) => {
    return (
        <div className={`icon-button button ${props.active && "active"}`} onClick={props.onClick}>
            {props.icon}
            <span>{props.title}</span>
        </div>
    );
};
